export function extractChildren(children) {
    var returnWith = [];
    if (!children) {
        return [];
    }
    if (Array.isArray(children)) {
        returnWith = children;
    }
    else {
        returnWith = [children];
    }
    return returnWith;
}
